import { FC } from "react";
import Container from "react-bootstrap/Container";
import ButtonGroup from "react-bootstrap/esm/ButtonGroup";
import { FaEdit } from "react-icons/fa";
import { useRouteParams } from "app/route/route";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { editReportVersionEngagementOverviewRoute, reportVersionEngagementOverviewRoute } from "app/route/Routes";
import { useReportVersionEngagementOverviewQuery } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { HtmlContent } from "app/component/util/HtmlContent";
import { Toolbar, ToolbarButtons, ToolbarTitle } from "app/component/util/Toolbar";
import { ButtonLink } from "app/component/button/ButtonLink";
import { useGeneralPermissions } from "app/api/graph/hook/use-general-permissions";

export const ReportVersionEngagementOverviewScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(reportVersionEngagementOverviewRoute);
    const { data, loading, error } = useReportVersionEngagementOverviewQuery({
        notifyOnNetworkStatusChange: true,
        variables: { versionId: reportVersionGraphId(versionId) },
    });
    const engagementOverview = data?.reportVersion?.engagementOverview;
    const { canUpdate } = useGeneralPermissions(engagementOverview?.permissions);

    if (loading && !engagementOverview) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!engagementOverview) {
        return <ErrorScreen title="Error" message="Not found." />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionEngagementOverviewRoute} />

                <Toolbar>
                    <ToolbarTitle>
                        <h1>Engagement overview</h1>
                    </ToolbarTitle>
                    <ToolbarButtons>
                        {canUpdate ? (
                            <ButtonGroup>
                                <ButtonLink
                                    to={editReportVersionEngagementOverviewRoute.build({ reportId, versionId })}
                                    variant="warning"
                                >
                                    <FaEdit /> Edit
                                </ButtonLink>
                            </ButtonGroup>
                        ) : null}
                    </ToolbarButtons>
                </Toolbar>

                <h2>Objectives</h2>
                <HtmlContent html={engagementOverview.objectives ?? "-"} />

                <h2>Rules of engagement</h2>
                <HtmlContent html={engagementOverview.rulesOfEngagement ?? "-"} />

                <h2>Limitations and exclusions</h2>
                <HtmlContent html={engagementOverview.limitationsAndExclusions ?? "-"} />
            </Container>
        </NavigationScreen>
    );
};
